module.exports = __webpack_public_path__ + "static/media/optionsMenu.b3f59b65.svg";